import React, { useState } from 'react';
import { Field } from 'formik';
import * as moment from 'moment';
import { FORMAT } from 'utils/dateOfBirthValidation';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import styled from 'styled-components';
import { useEffect } from 'react';


const DatePicker = (props) => {
  let dateSet = new Date();
  let date = new Date();
  let plusFourDays = date.setDate(date.getDate() + 4);
  let minDOBirth = new Date();
  let maxDOBirth = '';

  const [onChangeActive, setOnChangeActive] = useState(false);
  const locale = props?.locale || ((key) => key);
  const handleDateChange = (name, setFieldValue, setFieldError, date) => {
    setOnChangeActive(true)
    onChange(date)
    setFieldValue(name, moment(date).format(FORMAT));
  };
  
  let plusSeven = new Date().setDate(new Date().getDate() + 7);
  let plusTwentyTwo = new Date().setDate(new Date().getDate() + 56);
  let currentDate = new Date();
  minDOBirth = currentDate.setDate(currentDate.getDate() + 1);
  dateSet = new Date(currentDate)

  maxDOBirth = plusTwentyTwo
  // if(props.name == "addMoreArrList.[0].requestDeliveryDate"){
  //   maxDOBirth = new Date().setDate(new Date().getDate() + 22)
  // }
  // else{
  //   maxDOBirth = new Date(plusSeven);
  // }

  // }

  const [value, onChange] = useState(plusFourDays);

  useEffect(() => {  
    if(props.name === 'recStartDateTemp' || props.name === 'recEndDateTemp'){
      onChange(props.value)
    }
  }, [props])

  if(props.name === 'recStartDateTemp' || props.name === 'recEndDateTemp'){
    let currentDate = new Date();
    minDOBirth = moment(currentDate.setDate(currentDate.getDate() + 1)).format('MM/DD/YYYY');
    maxDOBirth = moment(currentDate.setDate(currentDate.getDate() + 365)).format('MM/DD/YYYY');
    if(props.minDOBirth) minDOBirth = props.minDOBirth
    if(props.maxDOBirth) maxDOBirth = props.maxDOBirth
  }

  return (
    <div>
      <Field name={props?.name}>
        {({ form, meta }) => {
          return (
            <DatePickerWrapper className={props.className}>
              <div className='custom-date-piker'>
                <div
                  className={`file-input-wrapper ${meta.touched && meta.error ? 'error' : ''
                    }`}
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disabled={props?.disabled ? props?.disabled : false}
                      minDate={props?.editResponse ? '' : minDOBirth}
                      maxDate={maxDOBirth}
                      name={props?.name}
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      value={props.selectedValue || value}
                      invalidDateMessage={locale("invalidDate")}
                      minDateMessage={locale("dateShouldNotBeBeforeMinimalDate")}
                      maxDateMessage={locale("dateShouldNotBeAfterMaxDate")}
                      // highlightDates={[
                      //   {
                      //     "highlighted-class": daysHighlighted.map((day, index) => {
                      //       day.setDate(day.getDate() + index)
                      //       return new Date(day)
                      //     }
                      //     )
                      //   }
                      // ]}
                      onChange={(date) => {
                        form.setFieldValue(props?.name, date)
                        handleDateChange(props?.name, form.setFieldValue, form.setFieldError, date)
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />

                  </MuiPickersUtilsProvider>

                </div>
              </div>
              {meta.error && <p name={props?.name + 'Error'} className="error-message">{meta.error}</p>}
            </DatePickerWrapper>
          );
        }}
      </Field>
    </div>
  );
};
export default DatePicker;

const DatePickerWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin: 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
  .MuiInput-underline:before {
    border-bottom: 1px solid #e0e0e0; 
  }
  &.responsive {
    .MuiInputBase-input {
  padding: 12px 0 13px;
  font-size: clamp(10px, 0.729vw, 14px);
}
.MuiSvgIcon-root {
  width: clamp(18px,1.25vw,24px);
  height: clamp(18px,1.25vw,24px);

}
 
  }
`
